import { render, staticRenderFns } from "./dsfieldForm.vue?vue&type=template&id=05123634&scoped=true&"
import script from "./dsfieldForm.vue?vue&type=script&lang=js&"
export * from "./dsfieldForm.vue?vue&type=script&lang=js&"
import style0 from "./dsfieldForm.vue?vue&type=style&index=0&id=05123634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05123634",
  null
  
)

export default component.exports